import { cn } from '@polyseme/utils/cn/cn-utils';
import Image from 'next/image';
import Link from 'next/link';

import { images } from '~/landing/assets';

type Props = { className?: string };

export const Header = ({ className }: Props) => {
  return (
    <header>
      <div
        className={cn(
          'mx-auto max-w-screen-2xl p-4 md:px-10 md:py-7',
          className
        )}
      >
        <Link
          aria-label="Garance"
          className="inline-block rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          href="https://www.garance.com/"
        >
          <Image
            priority
            alt=""
            className="h-auto w-32 md:w-[180px]"
            height={35}
            src={images.logo}
            width={180}
          />
        </Link>
      </div>
    </header>
  );
};
